import { apiGet } from '../generic/Api_Functions'
import downloadAsCsv from './csv_utils'
import { isSpecialBucket } from './loadCapacityFormat'
import { referenceYearOf, shortPeriodLabel } from './LoadCapacityChart'

// Story 177 (AP12), S192/S193 -- the CSV of "Export" in the load-and-capacity block: one row per column
// visible in the chart (the special one included, in the chart's order), eight columns, in hours, always all of
// them. The figures are the ones Sun sent, with one exception ratified by RN44 of story 153: "OEE loss" is
// the difference per column, max(calendar - OEE, 0). Nothing is requested from the planning service.
const FALLBACK_SEPARATOR = ';'

// At most one decimal, as the figures arrive from Sun; it only removes the floating point noise of a subtraction.
const oneDecimal = (value) => Math.round(value * 10) / 10

/** The header of the file, in the language of the user. */
export const loadCapacityCsvColumns = (t_) => [
  { name: t_('Period') },
  { name: t_('Firm load') },
  { name: t_('Forecast load') },
  { name: t_('Total load') },
  { name: t_('OEE capacity') },
  { name: t_('Calendar capacity') },
  { name: t_('OEE loss') },
  { name: t_('Excess') }
]

/**
 * One row per visible bucket. The special column (BACKLOG/OVERDUE) carries no capacity (S86 of story 153), so
 * its capacity, loss and excess cells are left empty.
 */
export const loadCapacityCsvRows = (buckets, t_) => {
  const referenceYear = referenceYearOf(buckets)
  return buckets.map((bucket) => {
    const period = shortPeriodLabel(bucket, referenceYear, t_)
    if (isSpecialBucket(bucket)) {
      return [period, bucket.firmLoadHours, bucket.forecastLoadHours, bucket.totalLoadHours, '', '', '', '']
    }
    return [
      period,
      bucket.firmLoadHours,
      bucket.forecastLoadHours,
      bucket.totalLoadHours,
      bucket.oeeCapacityHours,
      bucket.calendarCapacityHours,
      oneDecimal(Math.max(bucket.calendarCapacityHours - bucket.oeeCapacityHours, 0)),
      bucket.excessHours
    ]
  })
}

// The separator is the plant setting the details table CSV uses (`settings/character`).
const readCsvSeparator = async () => {
  try {
    const result = await apiGet('settings/character')
    return result[0].length !== 0 ? result[0] : FALLBACK_SEPARATOR
  } catch (unreadableSetting) {
    return FALLBACK_SEPARATOR
  }
}

/**
 * @param {Object} params
 * @param {Array<Object>} params.buckets The buckets the chart shows, in its order
 * @param {Function} params.t_ Translator
 * @param {String} params.filename File name, without extension
 */
const exportLoadCapacityCsv = async ({ buckets, t_, filename }) => {
  const separator = await readCsvSeparator()
  downloadAsCsv(loadCapacityCsvColumns(t_), loadCapacityCsvRows(buckets, t_), filename, separator)
}

export default exportLoadCapacityCsv
